import React from 'react'
import { observer, inject } from 'mobx-react'
import HeatMapSettings from './HeatMapSettings'
import LayerSettings from './LayerSettings'

const MapControls = ({ uiStore }) => {
  return (
    <div className='map-controls'>
      <HeatMapSettings />
      <LayerSettings />
      {/* <DateSettings /> */}
    </div>
  )
}

export default inject('uiStore')(observer(MapControls))
